import { Form, Input } from "antd";
import React from "react";

const SubjectEmail: React.FC = () => {
  return (
    <Form.Item
      name="email"
      label="Email"
      rules={[
        {
          type: "email",
          message: "Please enter a valid email address",
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default SubjectEmail;
